module.exports = __webpack_public_path__ + "static/media/jug.fe111670.svg";